<template>
  <div class="w-100">
    <TableBasic :payload="payload" />
  </div>
</template>

<script>
import TableBasic from "@/components/TableBasic.vue";
export default {
  components: {
    TableBasic,
  },
  data() {
    return {
      payload: {
        header: [
          {
            key: "order_id",
            label: "Order ID",
            class: "text-center",
          },
          {
            key: "seller_name",
            label: "Seller Name",
            class: "text-center",
          },
          {
            key: "order_total",
            label: "Order Total",
            class: "text-center",
          },
          {
            key: "seller_earning",
            label: "Seller Earning",
            class: "text-center",
          },
          {
            key: "comission",
            label: "Comission",
            class: "text-center",
          },
          {
            key: "gateway_fee",
            label: "Gateway Fee",
            class: "text-center",
          },
          {
            key: "shipping",
            label: "Shipping",
            class: "text-center",
          },
          {
            key: "tax",
            label: "Tax",
            class: "text-center",
          },
          {
            key: "date",
            label: "Date",
            class: "text-center",
          },
        ],
        value: [
          {
            order_id: "PMKT-123",
            seller_name: "Cwilapa",
            order_total: "Rp.35.000",
            seller_earning: "Rp.5.000",
            comission: "Rp.2.000",
            gateway_fee: "Rp.2.000",
            shipping: "Rp.10.000",
            tax: "Rp.3.500",
            date: "25 Jan 2022",
          },
        ],
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
      },
    };
  },
};
</script>

<style></style>
